export class CreateReportGenerationItemAction {
  static type = '[ReportGeneration] CreateReportGenerationItemAction';
  constructor(
    public generationId: string,
    public resultId: string,
    public kitId: string
  ) {}
}

export class FinishReportGenerationItemAction {
  static type = '[ReportGeneration] FinishReportGenerationItemAction';
  constructor(
    public generationId: string,
    public data: any
  ) {}
}
